<template>
    <picture>
        <source v-if="webpSrcSet" :data-srcset="webpSrcSet" type="image/webp" />
        <img
            :class="classes"
            :src="placeHolder"
            :data-srcset="jpgSrcSet"
            data-sizes="auto"
            :alt="alt"
            :style="inlineStyles"
        />
    </picture>
</template>

<script>
export default {
    props: {
        classes: {
            type: String,
            required: false,
            default: 'lazyload',
        },
        webpSrcSet: {
            type: String,
            required: false,
        },
        jpgSrcSet: {
            type: String,
            required: true,
        },
        alt: {
            type: String,
            required: false,
            default: 'Missing image title',
        },
        placeHolder: {
            type: String,
            required: false,
            default:
                'data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%271%27%20height%3D%271%27%20style%3D%27background%3Atransparent%27%2F%3E',
        },
        inlineStyles: {
            type: String,
            required: false,
            default: `object-fit: cover;object-position: 50% 50%;font-family: 'object-fit:cover;object-position:50% 50%;'`,
        },
    },
};
</script>
